module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_vm._v("About the Author")])]), _c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("P")]), _vm._v("aul Chrystal has classics degrees from the universities of Hull and Southampton and is the author of 100 or so published books, a number of which are about confectionery and beverages. He has written features on aspects of the history of food and drink for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Express")]), _vm._v(" and for a number of history magazines; he has appeared on the BBC World Service, Radio 4’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("PM")]), _vm._v(" programme and various BBC local radio stations talking on a wide range of subjects, but notably confectionery. Paul has also contributed to a six-part series for BBC2 ‘celebrating the history of some of Britain’s most iconic craft industries’ – in this case chocolate in York, which aired in 2019. He has been history advisor for a number of York tourist attractions relating to chocolate including ‘York’s Chocolate Experience’. He is also editor of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("York Historian")]), _vm._v(", the journal of the Yorkshire Architectural and York Archaeological Society. In 2019, he was guest speaker for the Vassar College (New York) London Programme with Goldsmiths University speaking to US social history students on the history of chocolate.")])]), _c('p', {
    staticClass: "right1"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    attrs: {
      "href": "mailto:paul.chrystal@btinternet.com"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("paul.chrystal@btinternet.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.paulchrystal.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.paulchrystal.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f60bcae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/About_the_Author.vue
// module id = 72
// module chunks = 0